import apiClient from "../utils/apiClient";

// Auth API endpoints
const authApi = {
  // Login
  login: async (email, password) => {
    try {
      const response = await apiClient(
        "/auth/login",
        "POST",
        { email, password },
        false // No auth required for login
      );

      if (response.data?.success) {
        // Store token in localStorage
        if (response.data?.data.token) {
          localStorage.setItem("authToken", response.data.data.token);
          localStorage.setItem("isAuthenticated", "true");
          localStorage.setItem("user", JSON.stringify(response.data.data.user));
        }
      }

      return response;
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Register
  register: async (userData) => {
    try {
      const response = await apiClient(
        "/auth/register",
        "POST",
        userData,
        false
      );

      if (response.success && response.data.token) {
        localStorage.setItem("authToken", response.data.token);
        localStorage.setItem("isAuthenticated", "true");
        localStorage.setItem("user", JSON.stringify(response.data.user));
      }

      return response;
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await apiClient("/auth/logout", "POST");

      // Clear localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");

      return response;
    } catch (error) {
      // Clear localStorage even if API call fails
      localStorage.removeItem("authToken");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user");

      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Get current user
  getCurrentUser: async () => {
    try {
      return await apiClient("/auth/me", "GET");
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Forgot password
  forgotPassword: async (email) => {
    try {
      return await apiClient("/auth/forgot-password", "POST", { email }, false);
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Reset password
  resetPassword: async (token, newPassword) => {
    try {
      return await apiClient(
        "/auth/reset-password",
        "POST",
        { token, newPassword },
        false
      );
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    try {
      return await apiClient("/auth/change-password", "POST", {
        currentPassword,
        newPassword,
      });
    } catch (error) {
      return {
        success: false,
        error: error.message,
      };
    }
  },
};

export default authApi;
